import * as React from "react";
import { ScrollIntoView } from "@grandvisionhq/common";
import { Heading } from "@grandvisionhq/elements";
import { Alert } from "@grandvisionhq/iris-ui";
import PasswordForm from "../../../../components/PasswordForm/components/PasswordForm/PasswordForm.js";
const SetPassword = ({
  labels,
  consentItems,
  onSubmit,
  hasErrors,
  passwordlessErrorMessage,
  isLoading
}) => /* @__PURE__ */ React.createElement("div", { className: "create-account myaccount__section" }, /* @__PURE__ */ React.createElement(Heading, { variant: "medium", component: "h1", className: "create-account__title" }, labels.title), /* @__PURE__ */ React.createElement("p", { className: "create-account__text" }, labels.text), Boolean(passwordlessErrorMessage) && /* @__PURE__ */ React.createElement(ScrollIntoView, { key: "passwordless-error" }, /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default" }, passwordlessErrorMessage)), hasErrors && /* @__PURE__ */ React.createElement(ScrollIntoView, { key: "default-error" }, /* @__PURE__ */ React.createElement(Alert, { variant: "error", className: "alert-m-default" }, labels.error)), /* @__PURE__ */ React.createElement(
  PasswordForm,
  {
    "data-t": "create-account-form",
    passwordLabel: labels.form.password,
    buttonCaption: labels.form.submit,
    onSubmit,
    isLoading
  },
  consentItems
));
export {
  SetPassword,
  SetPassword as default
};
//# sourceMappingURL=SetPassword.js.map
